<template>
  <div>
    <!-- hour-{{moment().format('A')}} <br>
    moment: {{moment(currentDate).format('DD') }} <br>
    today-{{currentDate.getDate()}}, Month-{{currentDate.getMonth()}}, Year-{{currentDate.getFullYear()}} -->
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Setup Exam
    </button>
    <a-modal
      v-model="visible"
      title="Setup a new exam"
      :width="1080"
      style="top: 20px"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :disabled="
            (form.getFieldValue(`class_id`) && classSubjects.length < 1) ||
              form.getFieldValue(`pass_mark`) > form.getFieldValue(`full_mark`)
          "
          :loading="loading"
          @click="handleSubmit"
          >Setup Exam</a-button
        >
      </template>
      <a-form :form="form">
        <div class="row mb-0">
          <!-- Select Session -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Session">
              <a-select
                v-decorator="[
                  'session_id',
                  {
                    rules: [
                      { required: true, message: 'Please select a session!!' }
                    ],
                    initialValue: currentSession ? currentSession.id : ''
                  }
                ]"
                placeholder="Select session"
                :disabled="true"
              >
                <a-select-option
                  v-for="schoolSession in schoolSessions"
                  :value="schoolSession.id"
                  :key="schoolSession.id"
                >
                  {{ schoolSession.name }}
                  <small class="text-primary ml-3">{{
                    currentSession.id === schoolSession.id ? "Current" : ""
                  }}</small>
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <!-- Select Class -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Class">
              <a-spin :spinning="classSpinning">
                <a-select
                  v-decorator="[
                    'class_id',
                    {
                      rules: [
                        { required: true, message: 'Please select a class!!' }
                      ],
                      initialValue: undefined
                    }
                  ]"
                  placeholder="Select class"
                  @change="handleClassSelect"
                >
                  <a-select-option :value="undefined">
                    Select class
                  </a-select-option>
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option
                      :value="schoolClass.id"
                      :key="schoolClass.id"
                    >
                      {{ schoolClass.name }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>
          <!-- Select Section -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Sections">
              <a-spin :spinning="sectionSpinning">
                <a-checkbox-group
                  :disabled="true"
                  v-decorator="[
                    'sections',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please select a section!!'
                        }
                      ],
                      initialValue: [0]
                    }
                  ]"
                  @change="handleSectionAllSelect"
                >
                  <a-checkbox
                    :value="0"
                    :disabled="!form.getFieldValue('class_id')"
                  >
                    All
                  </a-checkbox>
                  <template class="col-4" v-for="section in sections">
                    <a-checkbox
                      :value="section.id"
                      :key="section.id"
                      :disabled="isAllSections"
                    >
                      {{ section.name }}
                    </a-checkbox>
                  </template>
                </a-checkbox-group>
              </a-spin>
            </a-form-item>
          </div>
          <!-- Enabled Common F.M. and P.M. checkbox-->
          <div class="col-md-3 mb-2">
            <a-form-item label="Take Common F.M. and P.M.">
              <!-- <a-checkbox @change="onEnabledChange">
                {{ enabled_status }}
              </a-checkbox> -->
              <a-checkbox
                v-decorator="[
                  'common_fm_pm',
                  {
                    valuePropName: 'checked',
                    initialValue: false
                  }
                ]"
                @change="resetMark"
              >
                {{
                  form.getFieldValue("common_fm_pm") ? "Enabled" : "Disabled"
                }}
              </a-checkbox>
            </a-form-item>
          </div>

          <!-- Select Exam -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Select Exam">
              <a-select
                v-decorator="[
                  'exam_id',
                  {
                    rules: [
                      { required: true, message: 'Please select an exam!!' }
                    ]
                  }
                ]"
                placeholder="Select Exam"
              >
                <a-select-option
                  v-for="schoolExam in schoolExams"
                  :value="schoolExam.id"
                  :key="schoolExam.id"
                >
                  {{ schoolExam.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <!-- Exam setting -->
          <div class="col-md-3 mb-2">
            <a-form-item label=" Select Exam Setting">
              <a-select
                v-decorator="[
                  'exam_setting_id',
                  {
                    rules: [
                      { required: true, message: 'Please enter Full Mark!!' }
                    ]
                  }
                ]"
                placeholder="Select Exam Setting"
              >
                <a-select-option
                  v-for="Examsetting in examsettingdata"
                  :value="Examsetting.id"
                  :key="Examsetting.id"
                >
                  {{ Examsetting.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <!-- Select is grades enabled -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Enable grades">
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'grades',
                  {
                    rules: [
                      { required: true, message: 'This value is required' }
                    ],
                    initialValue: 0
                  }
                ]"
              >
                <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <!-- full mark -->
          <div class="col-md-3 mb-2" id="common_mark_container">
            <a-form-item label="Full Marks :">
              <a-input-number
                v-decorator="[
                  'full_mark',
                  {
                    rules: [
                      {
                        required: form.getFieldValue('common_fm_pm'),
                        message: 'Please enter Full Mark!!'
                      }
                    ],
                    initialValue: f_mark
                  }
                ]"
                placeholder="Full Mark"
                style="width: 200px"
                :disabled="!form.getFieldValue('common_fm_pm')"
                @keyup="setSubjectFullMark"
              />
            </a-form-item>
          </div>

          <!-- Declare_all_section -->
          <div class="col-md-3 mb-2">
            <a-form-item label="Declare All Section">
              <a-radio-group
                :disabled="true"
                v-decorator="[
                  'declare_all_section',
                  {
                    rules: [
                      { required: true, message: 'This value is required' }
                    ],
                    initialValue: 1
                  }
                ]"
              >
                <a-radio :value="1">Yes</a-radio>
                <a-radio :value="0">No</a-radio>
              </a-radio-group>
            </a-form-item>
          </div>
          <div class="col-md-6 mb-2"></div>
          <!-- pass mark -->
          <div class="col-md-3 mb-2" id="common_mark_container">
            <a-form-item label="Pass Marks :">
              <a-input-number
                v-decorator="[
                  'pass_mark',
                  {
                    rules: [
                      {
                        required: form.getFieldValue('common_fm_pm'),
                        message: 'Please enter Pass Mark!!'
                      }
                    ],
                    initialValue: p_mark
                  }
                ]"
                placeholder="Pass Mark"
                style="width: 200px"
                :disabled="!form.getFieldValue('common_fm_pm')"
                @keyup="setSubjectPassMark"
              />
              <p
                v-if="
                  form.getFieldValue('pass_mark') >
                    form.getFieldValue('full_mark')
                "
                class="text-danger"
              >
                Pass mark should be less than full mark !!
              </p>
            </a-form-item>
          </div>
          <div class="col-md-12" v-if="classSubjects.length > 0">
            <a-divider />
            <p class="font-weight-bold mt-3">Setup Exam Subjects</p>
            <a-spin :spinning="sectionSpinning">
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>Sl</th>
                      <th>#</th>
                      <th>Subject</th>
                      <th>Full Mark</th>
                      <th>Pass Mark</th>
                      <th>Exam Date</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Grades only</th>
                      <th>Oral</th>
                      <th>No exam</th>
                      <th>In total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="subject in classSubjects" :key="subject.id">
                      <th>
                        <a-form-item>
                          <a-input
                            placeholder=""
                            v-decorator="[
                              `subjects[${subject.subject_id}][sl_no]`,

                              {
                                rules: [
                                  {
                                    required:
                                      form.getFieldValue(
                                        `subjects[${subject.subject_id}][selected]`
                                      ) &&
                                      !form.getFieldValue('common_fm_pm'),
                                    message: 'Required!!'
                                  }
                                ],
                                initialValue: null
                              }
                            ]"
                            @blur='onChangeTestSl_no($event, subject.subject_id)'
                            :disabled='!form.getFieldValue(`subjects[${subject.subject_id}][selected]`)'
                            :min="0"
                            style="width: 100%"
                          />
                        </a-form-item>
                      </th>
                      <th
                        style="min-width: 30px; vertical-align: middle"
                        class="text-center"
                      >
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][selected]`,
                              { valuePropName: 'checked', initialValue: false }
                            ]"
                            @change='onSubjectSelectedChange($event,subject.subject_id)'
                          >
                          </a-checkbox>
                        </a-form-item>
                      </th>
                      <td
                        style="
                          min-width: 150px;
                          vertical-align: middle;
                          padding: 0.5rem;
                        "
                      >
                        {{ subject.subject.name }}
                        <a-form-item class="d-none">
                          <a-input
                            v-decorator="[
                              `subjects[${subject.subject_id}][subject_id]`,
                              {
                                rules: [
                                  { required: true, message: 'Required' }
                                ],
                                initialValue: subject.subject_id
                              }
                            ]"
                          />
                        </a-form-item>
                      </td>
                      <td style="min-width: 80px">
                        <a-form-item>
                          <a-input-number
                            placeholder=""
                            v-decorator="[
                              `subjects[${subject.subject_id}][full_mark]`,
                              {
                                rules: [
                                  {
                                    required:
                                      form.getFieldValue(
                                        `subjects[${subject.subject_id}][selected]`
                                      ) &&
                                      !form.getFieldValue('common_fm_pm') &&
                                      !form.getFieldValue(
                                        `subjects[${subject.subject_id}][grades_only]`
                                      ),
                                    message: 'Required!!'
                                  }
                                ],
                                initialValue:
                                  !form.getFieldValue(
                                    `subjects[${subject.subject_id}][grades_only]`
                                  ) &&
                                  form.getFieldValue('common_fm_pm') &&
                                  form.getFieldValue(
                                    `subjects[${subject.subject_id}][selected]`
                                  )
                                    ? form.getFieldValue('full_mark')
                                    : ''
                              }
                            ]"
                            :min="0"
                            @keyup="getPassMarkInputValue($event, subject.subject_id)"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) ||
                                form.getFieldValue(
                                  `subjects[${subject.subject_id}][grades_only]`
                                ) ||
                                form.getFieldValue('common_fm_pm')
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="min-width: 80px">
                        <a-form-item>
                          <a-input-number
                            placeholder=""
                            v-decorator="[
                              `subjects[${subject.subject_id}][pass_mark]`,
                              {
                                rules: [
                                  {
                                    validator:
                                      form.getFieldValue(
                                        `subjects[${subject.subject_id}][selected]`
                                      ) &&
                                      !form.getFieldValue('common_fm_pm') &&
                                      !form.getFieldValue(
                                        `subjects[${subject.subject_id}][grades_only]`
                                      )
                                        ? checkSubjectPassMarks
                                        : ''
                                  }
                                ],
                                initialValue:
                                  !form.getFieldValue(
                                    `subjects[${subject.subject_id}][grades_only]`
                                  ) &&
                                  form.getFieldValue('common_fm_pm') &&
                                  form.getFieldValue(
                                    `subjects[${subject.subject_id}][selected]`
                                  )
                                    ? form.getFieldValue('pass_mark').toString()
                                    : ''
                              }
                            ]"
                            :min="0"
                            @change="getFullMarkInputValue(subject.subject_id)"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) ||
                                form.getFieldValue(
                                  `subjects[${subject.subject_id}][grades_only]`
                                ) ||
                                form.getFieldValue('common_fm_pm') ||
                                !form.getFieldValue(
                                  `subjects[${subject.subject_id}][full_mark]`
                                )
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="min-width: 130px">
                        <a-form-item>
                          <a-date-picker
                            :disabledDate="disabledDate"
                            v-decorator="[
                              `subjects[${subject.subject_id}][date]`,
                              {
                                rules: [
                                  {
                                    required: form.getFieldValue(
                                      `subjects[${subject.subject_id}][selected]`
                                    ),
                                    message: 'Please input a start date'
                                  }
                                ]
                              }
                            ]"
                            @change="getSelectedDate"
                            :format='dateFormat'
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                            style="width: 100%"
                          />
                        </a-form-item>
                      </td>
                      <td style="min-width: 130px">
                        <a-form-item>
                          <a-time-picker
                          :disabledHours='getDisabledHours'
                          :disabledMinutes='getDisabledMinutes'
                            v-decorator="[
                              `subjects[${subject.subject_id}][start_time]`,
                              {
                                rules: [
                                  {
                                    required: form.getFieldValue(
                                      `subjects[${subject.subject_id}][selected]`
                                    ),
                                    message: 'Please input an start time'
                                  }
                                ]
                              }
                            ]"
                            use12Hours
                            :format="timeFormat"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][date]`
                              ) &&
                              form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) !== null || '' ? true : false
                            "
                            @change="getEndTimeSetting($event, subject.subject_id)"
                            style="width: 100%"
                          >
                          </a-time-picker>
                        </a-form-item>
                      </td>
                      <td style="min-width: 130px">
                        <a-form-item>
                          <a-time-picker
                          :disabledHours='getEndDisabledHours'
                          :disabledMinutes='getEndDisabledMinutes'
                          :A='getAMPM'
                            v-decorator="[
                              `subjects[${subject.subject_id}][end_time]`,
                              {
                                rules: [
                                  {
                                    required: form.getFieldValue(
                                      `subjects[${subject.subject_id}][selected]`
                                    ),
                                    message: 'Please input an end time'
                                  }
                                ]
                              }
                            ]"
                            use12Hours
                            :format="timeFormat"
                            :disabled="
                            !form.getFieldValue(
                                `subjects[${subject.subject_id}][start_time]`
                              ) &&
                              form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) !== null || '' ? true : false
                            "
                            @change="getEndTimeSetting($event, subject.subject_id)"
                            style="width: 100%"
                          >
                          </a-time-picker>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][grades_only]`,
                              { valuePropName: 'checked', initialValue: false }
                            ]"
                            @change="
                              changeMarkFieldData($event, subject.subject_id)
                            "
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) ||
                                form.getFieldValue(
                                  `subjects[${subject.subject_id}][is_in_total]`
                                )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][is_oral]`,
                              { valuePropName: 'checked', initialValue: false }
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) !== null || '' ? true : false
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][has_exam]`,
                              { valuePropName: 'checked', initialValue: false }
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                      <td style="min-width: 50px" class="text-center">
                        <a-form-item>
                          <a-checkbox
                            v-decorator="[
                              `subjects[${subject.subject_id}][is_in_total]`,
                              { valuePropName: 'checked', initialValue: false }
                            ]"
                            :disabled="
                              !form.getFieldValue(
                                `subjects[${subject.subject_id}][selected]`
                              ) ||
                                form.getFieldValue(
                                  `subjects[${subject.subject_id}][grades_only]`
                                )
                            "
                          >
                          </a-checkbox>
                        </a-form-item>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </a-spin>
          </div>

          <div
            v-if="form.getFieldValue(`class_id`) && classSubjects.length < 1"
            class="col-md-12 py-2"
          >
            <h5 class="text-danger">Cannot Setup Exam!</h5>
            <strong class="text-danger"
              >No subjects found for this class! Please check the class setup
              for the selected class to add subjects.</strong
            >
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'

export default {
  name: 'AddExamSetup',
  mounted: function() {
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id

        this.getClasses()
        this.getExamsSetting()
      })
      .catch(error => {
        console.log(error)
      })
    this.getExams()
    this.resetMark()
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    errorMessage: function(value) {
      return value
    },
    enableSubmitStat: function(value) {
      return value
    },
    // get current subject full mark
    getCurrentSubjectFullMark: function(value) {
      return value
    },
    // get count value
    count: function(value) {
      return value
    },
    // get current pass mark
    getCurrentSubjectPassMark: function(value) {
      return value
    },
    currentSession: function(val) {
      this.selectedSession = val.id
    },
    isAllSections: function(val) {
      if (val) {
        this.form.setFieldsValue({ sections: [0] })
      }
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      examLoading: false,
      schoolExams: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      classSubjects: [],
      selectedSession: undefined,
      isAllSections: true,
      classSpinning: false,
      sectionSpinning: false,
      subjectSpinning: false,
      dateFormat: 'DD-MM-YYYY',
      timeFormat: 'h:mm a',
      showMarkField: false,
      enabled_status: 'Disabled',
      f_mark: '',
      p_mark: '',
      show_columns: true,
      examsettingdata: [],
      changeData: '',
      getCurrentSubjectFullMark: '',
      // getCurrentSubjectPassMark:'',
      count: 1,
      enableSubmitStat: false,
      errorMessage: '',
      value2: moment(),
      selectedEndHour: '',
      selectedEndMinute: '',
      currentDate: new Date(),
      selectedDate: '',
    }
  },
  methods: {
    moment,
    // getEndDisabledHours
    // getEndDisabledMinutes
    // disabled pass hours
    getAMPM () {
      // const AMPM = moment().format('A')
      let a = 'am'
      return a
    },
    getSelectedDate(e) {
      this.selectedDate = parseInt(moment(e).format('DD'))
      // const currentDate = parseInt(this.currentDate.getDate())
      // if (this.selectedDate === currentDate) {
      //   alert(this.selectedDate)
      // }
    },
    getDisabledHours () {
      if (parseInt(this.currentDate.getDate()) === this.selectedDate) {
        var hours = []
        for (var i = 0; i < moment().hour(); i++) {
          hours.push(i)
        }
        return hours
      }
    },
    // disabled pass min
    getDisabledMinutes(selectedHour) {
      if (parseInt(this.currentDate.getDate()) === this.selectedDate) {
        var minutes = []
        if (selectedHour === moment().hour()) {
          for (var i = 0; i < moment().minute(); i++) {
            minutes.push(i)
          }
        }
        return minutes
      }
    },
    // disabled hours in end time
    getEndDisabledHours () {
      var hours = []
      for (var i = 0; i < this.selectedEndHour; i++) {
        hours.push(i)
      }
      return hours
    },
    // use -- :disabledMinutes='getEndDisabledMinutes'
    getEndDisabledMinutes(selectedHour) {
      if (parseInt(this.currentDate.getDate()) === this.selectedDate) {
        var minutes = []
        if (selectedHour) {
          for (var i = 0; i < this.selectedEndMinute; i++) {
            minutes.push(i)
          }
        }
        return minutes
      }
    },
    // get end time on chnage value
    getEndTimeSetting(e) {
      if (e) {
        var __hour = moment(e).hour()
        // var _hour = __hour <= 12 ? (__hour === 0 ? 12 : __hour) : __hour - 12
        this.selectedEndHour = __hour
        this.selectedEndMinute = moment(e).minute()
        console.log('hour', this.selectedEndHour)
        console.log('min', this.selectedEndMinute)
      }
    },
    setSubjectFullMark() {
      // alert(e.target.value)
      this.classSubjects.forEach((value) => {
        // eslint-disable-next-line space-before-blocks
        if (this.form.getFieldValue(`subjects[${value.subject_id}][selected]`)){
          this.form.setFieldsValue({
            [`subjects[${value.subject_id}][full_mark]`]: this.form.getFieldValue('full_mark'),
          })
        }
      })
    },
    setSubjectPassMark() {
      // alert(e.target.value)
      this.classSubjects.forEach((value) => {
        // eslint-disable-next-line space-before-blocks
        if (this.form.getFieldValue(`subjects[${value.subject_id}][selected]`)){
          this.form.setFieldsValue({
            [`subjects[${value.subject_id}][pass_mark]`]: this.form.getFieldValue('pass_mark').toString(),
          })
        }
      })
    },
    onChangeTestSl_no(e, subject) {
      // alert(e.target.value)
      if (isNaN(e.target.value)) {
        this.$message.error('Please input a number!')
        this.form.setFieldsValue({
          [`subjects[${subject}][sl_no]`]: '',
        })
      } else {
        if (e.target.value != null && e.target.value > 0) {
          if (e.target.value !== null) {
            this.classSubjects.forEach((value) => {
              if (value.subject_id !== subject) {
                // alert(e.target.value)
                if (e.target.value !== null) {
                  if (this.form.getFieldValue(`subjects[${value.subject_id}][sl_no]`) === e.target.value
                  ) {
                    // if()
                    this.$message.error('Sl no. must be a number and cannot duplicate!!')
                    this.form.setFieldsValue({
                      [`subjects[${subject}][sl_no]`]: '',
                    })
                  }
                }
              }
            })
          }
        } else {
          this.$message.error('Please input a number greater than 0!')
          this.form.setFieldsValue({
            [`subjects[${subject}][sl_no]`]: '',
          })
        }
      }
    },
    onSubjectSelectedChange(e, subjectId) {
      if (!e.target.checked) {
        this.form.resetFields([
          `subjects[${subjectId}][sl_no]`,
          `subjects[${subjectId}][full_mark]`,
          `subjects[${subjectId}][pass_mark]`,
          `subjects[${subjectId}][date]`,
          `subjects[${subjectId}][start_time]`,
          `subjects[${subjectId}][end_time]`,
          `subjects[${subjectId}][grades_only]`,
          `subjects[${subjectId}][is_oral]`,
          `subjects[${subjectId}][has_exam]`,
          `subjects[${subjectId}][is_in_total]`,
        ])
        this.form.setFieldsValue({
          [`subjects[${subjectId}][sl_no]`]: '',
        })
        this.form.setFieldsValue({
          [`subjects[${subjectId}][full_mark]`]: '',
        })
        this.form.setFieldsValue({
          [`subjects[${subjectId}][pass_mark]`]: '',
        })
      } else {
        this.form.setFieldsValue({
          [`subjects[${subjectId}][full_mark]`]: this.form.getFieldValue('full_mark').toString(),
        })
        this.form.setFieldsValue({
          [`subjects[${subjectId}][pass_mark]`]: this.form.getFieldValue('pass_mark').toString(),
        })
      }
    },
    // get input subject pass mark
    getPassMarkInputValue(e, subject) {
      // alert(e.target.value)
      if (e.target.value < 1) {
        this.$message.warning('Full mark must greater than 0!!')
        this.form.setFieldsValue({
          [`subjects[${subject}][full_mark]`]: '',
        })
      } else {
        this.getCurrentSubjectPassMark = parseInt(
          this.form.getFieldValue([`subjects[${subject}][pass_mark]`]),
        )
      }
    },
    // get input subject full mark
    getFullMarkInputValue(subject) {
      if (!this.form.getFieldValue(`subjects[${subject}][full_mark]`)) {
        this.$message.warning('Please fill full mark first!!')
        // this.form.setFieldsValue({
        //     [`subjects[${value.subject_id}][full_mark]`]: '',
        //   })
        this.form.setFieldsValue({
          [`subjects[${subject}][pass_mark]`]: null,
        })
      }
      this.getCurrentSubjectFullMark = parseInt(
        this.form.getFieldValue(`subjects[${subject}][full_mark]`)
      )
    },
    // validation function for subject pass mark
    checkSubjectPassMarks(value, callbacks) {
      if (value > 0) {
        if (value >= this.getCurrentSubjectFullMark) {
          callbacks('Pass mark must less than full mark!')
        } else {
          callbacks()
        }
      } else {
        callbacks('Required!!')
      }
    },
    changeMarkFieldData(e, subject) {
      if (e.target.checked && subject) {
        this.form.setFieldsValue({ 'subjects[subject][full_mark]': '' })
        this.form.setFieldsValue({ 'subjects[subject][pass_mark]': '' })
        this.form.resetFields([
          `subjects[${subject}][full_mark]`,
          `subjects[${subject}][pass_mark]`,
        ])
      }
    },
    resetMark(e) {
      if (!e.target.checked) {
        this.form.setFieldsValue({ 'full_mark': '' })
        this.form.setFieldsValue({ 'pass_mark': '' })
        this.classSubjects.forEach((value) => {
          this.form.setFieldsValue({
            [`subjects[${value.subject_id}][full_mark]`]: '',
          })
          this.form.setFieldsValue({
            [`subjects[${value.subject_id}][pass_mark]`]: '',
          })
          this.form.resetFields([
            `subjects[${value.subject_id}][full_mark]`,
            `subjects[${value.subject_id}][pass_mark]`,
          ])
        })
      } else {
        // console.log(this.classSubjects);
        this.classSubjects.forEach((value) => {
          this.form.setFieldsValue({
            [`subjects[${value.subject_id}][full_mark]`]: '',
          })
          this.form.setFieldsValue({
            [`subjects[${value.subject_id}][pass_mark]`]: '',
          })
          this.form.resetFields([
            `subjects[${value.subject_id}][full_mark]`,
            `subjects[${value.subject_id}][pass_mark]`,
          ])
        })
      }
    },
    showModal() {
      this.visible = true
    },
    getExams() {
      this.examLoading = true
      this.$http
        .get('/api/exam', {
          params: {
            limit: 15,
          },
        })
        .then(({ data }) => {
          this.examLoading = false
          this.schoolExams = data.data
        })
    },
    getExamsSetting: function() {
      // this.classSpinning = true;
      this.$http
        .get('/api/exam/settings/all', {
          session_id: this.selectedSession,
        })
        .then(({ data }) => {
          // console.warn(data.data)
          this.examsettingdata = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClassSubjects(classId) {
      this.$http
        .get(`/api/subject/class/${classId}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.classSubjects = data.data.all
          this.subjectSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.form.resetFields(['sections'])
      this.count = 0
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
        this.getClassSubjects(value)
      }
    },
    getClassSections(value) {
      this.$http
        .get(`/api/section/class/${value}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionAllSelect(value) {
      if (value.includes(0)) {
        this.isAllSections = true
      } else {
        this.isAllSections = false
      }
    },
    handleSubmit() {
      // this.loading = true;
      this.classSubjects.forEach((value) => {
        if (this.form.getFieldValue(`subjects[${value.subject_id}][selected]`)) {
          // if (!this.form.getFieldValue(`subjects[${value.subject_id}][sl_no]`)
          // ) {
          //   this.enableSubmitStat = false
          //   this.errorMessage = 'Please fill the selected subjects Sl.!!'
          // // this.$message.error('')
          // } else {
          //   this.enableSubmitStat = true
          // }
          if (!this.form.getFieldValue(`subjects[${value.subject_id}][sl_no]`)
          ) {
            this.enableSubmitStat = false
            this.errorMessage = 'Please fill the selected subjects Sl.!!'
          // this.$message.error('')
          } else if (!this.form.getFieldValue(`subjects[${value.subject_id}][grades_only]`) && !this.form.getFieldValue(`subjects[${value.subject_id}][is_in_total]`)) {
            this.errorMessage = 'Required grade only or total!!'
            this.enableSubmitStat = false
          } else {
            this.enableSubmitStat = true
          }
        }
      })
      if (this.enableSubmitStat === false) {
        if (this.errorMessage !== '') {
          this.$message.error(this.errorMessage)
        }
      } else {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.$confirm({
              title: `Are you sure you want to add ${values.name}?`,
              content: `Click on the OK button to setup class exam!`,
              onOk: () => {
                const formData = this.makeFormData(values)
                if (formData.subjects.length !== 0) {
                  // eslint-disable-next-line camelcase
                  const subjects_data = formData.subjects.sort(function(a, b) {
                    return a.sl_no - b.sl_no
                  })
                  // console.log(subjects_data)
                  this.$http
                    .post('/api/classsectionexam', {
                      class_id: formData.class_id,
                      declare_all_section: formData.declare_all_section,
                      exam_id: formData.exam_id,
                      exam_setting_id: formData.exam_setting_id,
                      grades: formData.grades,
                      is_all_section: formData.is_all_section,
                      sections: formData.sections,
                      session_id: formData.session_id,
                      subjects: subjects_data,
                    })
                    .then(() => {
                      this.$emit('created')
                      this.loading = false
                      this.visible = false
                      this.$notification['success']({
                        message: 'Setup successful!',
                        description: `Exam has been successfully setup!`,
                      })
                      this.form.resetFields()
                    })
                    .catch(error => {
                      this.loading = false
                      this.$neoNotify.error(error)
                    })
                } else {
                  this.$message.error('No subject is selected!')
                }
              },
              onCancel: () => {
                this.loading = false
              },
            })
          }

          this.loading = false
        })
      }
    },
    handleCancel() {
      this.form.resetFields()
      this.visible = false
    },
    disabledDate(current) {
      // Can not select days before today
      return current < moment().startOf('day')
    },
    makeFormData(values) {
      const subjects = values.subjects
        .filter(element => {
          return element.selected
        })
        .map(element => {
          delete element['selected']

          element.date = moment(element.date).format('YYYY-MM-DD')

          element.start_time = moment(element.start_time).format('HH:mm:ss')
          element.end_time = moment(element.end_time).format('HH:mm:ss')

          element.grades_only = element.grades_only ? 1 : 0
          element.is_oral = element.is_oral ? 1 : 0
          element.has_exam = element.has_exam ? 0 : 1
          element.is_in_total = element.is_in_total ? 1 : 0

          return element
        })

      values.is_all_section = 0

      if (values.sections.includes(0)) {
        values.sections = this.sections.map(element => {
          return element.id
        })
        values.is_all_section = 1
      }

      values.subjects = subjects
      return values
    },
  },
}
</script>
<style scoped>
#common_mark_container {
  display: flex;
  /* justify-content: center; */
}
.PM_content {
  margin-left: 65px;
  width: 400px;
}
</style>
